"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineAdsPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const machine_ads_1 = require("../../sections/machine-ads");
const AdvertisingContext_1 = require("../../sections/advertising/context/AdvertisingContext");
const MachineAdsPage = () => {
    return ((0, jsx_runtime_1.jsx)(AdvertisingContext_1.AdvertisingProvider, { children: (0, jsx_runtime_1.jsx)(machine_ads_1.MachineAds, {}) }));
};
exports.MachineAdsPage = MachineAdsPage;
